/**
 * Urlopy (`lv.*`, NX-421): widok /leave — salda zespołu z InsERT i NEXOPS, kalendarz, oś, nadchodzące, wnioski
 * z kolizjami, ręczny wymiar i powiązanie pracowników kadr z kontami. Angielski: `leave-en.ts`.
 */
export const lvPl = {
  nav: 'Urlopy',
  title: 'Urlopy',
  description: 'Kto jest na urlopie, salda zespołu z InsERT i grafiku NEXOPS, kalendarz, oś roku i wnioski do decyzji.',
  close: 'Zamknij',
  moved: {
    title: 'Urlopy mają osobny widok',
    body: 'Wymiar i zaległy urlop, salda z InsERT i grafiku, kalendarz oraz wnioski do decyzji są w widoku Urlopy.',
    noAccess: 'Wymiar i salda urlopu prowadzą kadry i kierownicy w widoku Urlopy.',
    open: 'Otwórz Urlopy',
  },
  days: '{value} dni',
  hours: '{value} h',
  year: { prev: 'Poprzedni rok', next: 'Następny rok', label: 'Rok' },
  hero: {
    people: 'Osoby',
    over: 'Ponad pulą',
    lowHint: 'mało dni: {n}',
    used: 'Wykorzystane dni',
    plannedHint: 'zaplanowane: {n}',
    utilization: 'Wykorzystanie puli',
    pending: 'Wnioski do decyzji',
    today: 'Dziś na urlopie',
    peakHint: 'szczyt: {day} ({n} os.)',
    elapsedHint: 'rok minął w {pct}',
    left: 'Dni do wykorzystania',
    manyHint: '{n} os. ma 10+ dni',
  },
  insight: {
    pending: 'Wnioski urlopowe czekające na Twoją decyzję: {n}.',
    pendingAction: 'Rozpatrz',
    carriedLate: '{n} os. nie wykorzystało w terminie (30 września) zaległego urlopu z {year} — razem {days} dni.',
    show: 'Pokaż',
    peak: 'Dziś na urlopie: {n} os. Najwięcej osób w najbliższych 60 dniach: {day} ({k} os.).',
    calendar: 'Kalendarz',
  },
  sort: { label: 'Sortowanie', name: 'Wg nazwiska', remaining: 'Najwięcej do wykorzystania', used: 'Najwięcej wykorzystanych' },
  ov: {
    people: '{n} os.',
    erpOnly: 'z InsERT',
    today: {
      title: 'Dziś na urlopie',
      empty: 'Dziś nikt nie ma urlopu',
      back: 'wraca',
      next: 'Następny dzień roboczy ({day}): na urlopie {n} os.',
    },
    months: {
      title: 'Urlopy w miesiącach {year}',
      description: '{total} osobodni urlopu w roku · najwięcej: {peak}',
      empty: 'Brak urlopów w tym roku',
      total: 'Osobodni urlopu',
      perDay: 'średnio {n} os. na urlopie dziennie',
      future: 'urlopy już zaplanowane',
      hint: 'Dni robocze, każda osoba raz. Kliknij miesiąc, żeby otworzyć kalendarz.',
    },
    pool: {
      title: 'Pula urlopowa zespołu',
      description: '{n} os. z wymiarem z InsERT lub NEXOPS · razem {days} dni',
      usedOfPool: 'puli wykorzystane',
      elapsed: 'rok minął w {pct}',
      used: 'Wykorzystane',
      planned: 'Zaplanowane',
      left: 'Do wykorzystania',
      pace: {
        slow: 'Zespół bierze urlop wolniej, niż mija rok.',
        ok: 'Tempo wykorzystania urlopu zgodne z upływem roku.',
        fast: 'Zespół wykorzystuje urlop szybciej, niż mija rok.',
      },
      projection: 'Przy obecnym tempie na koniec roku zostanie ok. {days} dni zaległego urlopu.',
      over: 'Ponad pulą: {days} dni u {n} os.',
    },
    carried: {
      title: 'Zaległy urlop z {year}',
      description: 'Do udzielenia do 30 września {year} (Kodeks pracy art. 168)',
      empty: 'Zaległy urlop wykorzystany w terminie',
      late: 'Po terminie: {n} os. nie wykorzystało {days} dni zaległego urlopu.',
      soon: 'Do terminu {left} dni: {n} os. ma jeszcze {days} dni zaległego urlopu.',
      row: 'zaległy {carried} · wykorzystane do 30.09: {used}',
    },
    busiest: {
      title: 'Najbardziej obłożone dni',
      description: 'Najwięcej osób na urlopie w najbliższych 60 dniach',
      empty: 'Brak urlopów w najbliższych 60 dniach',
    },
    upcoming: {
      title: 'Nadchodzące urlopy',
      description: 'Urlopy zaczynające się w najbliższych 60 dniach',
      thisWeek: 'Ten tydzień',
      nextWeek: 'Przyszły tydzień',
      later: 'Później',
      none: 'Brak',
      more: 'i {n} więcej',
    },
    leaders: {
      title: 'Najwięcej dni do wykorzystania',
      description: '{n} os. ma co najmniej {days} dni urlopu do wykorzystania',
      empty: 'Nikt nie ma niewykorzystanego urlopu',
    },
  },
  erp: {
    status: '{employees} pracowników z Gratyfikanta, {linked} powiązanych z kontami · ostatni import: {at}',
    never: 'jeszcze nie było',
    toLink: '{n} do powiązania',
    short: 'InsERT: {employees} pracowników ({linked} z kontem) · import {at}',
  },
  tabs: { overview: 'Przegląd', team: 'Zespół', calendar: 'Kalendarz', timeline: 'Oś roku', requests: 'Wnioski', link: 'Do powiązania' },
  source: { MANUAL: 'Ręcznie', ERP: 'InsERT', DEFAULT: 'Domyślny', NEXOPS: 'NEXOPS', REQUEST: 'Wniosek' },
  sourceHint: {
    MANUAL: 'Wymiar wpisany ręcznie w NEXOPS — ma pierwszeństwo przed InsERT.',
    ERP: 'Wymiar i zaległy urlop z Gratyfikanta (InsERT).',
    DEFAULT: 'Domyślny wymiar organizacji — brak wpisu w NEXOPS i w InsERT.',
  },
  status: { over: 'Ponad pulą', low: 'Mało', ok: 'W normie' },
  account: { label: 'Konto', withData: 'Z danymi', all: 'Wszyscy', account: 'Z kontem', erpOnly: 'Tylko InsERT' },
  group: { label: 'Grupowanie', none: 'Bez grup', status: 'Wg salda', department: 'Wg działu' },
  team: {
    search: 'Szukaj osoby',
    allDepartments: 'Wszystkie działy',
    allStatuses: 'Każde saldo',
    noDepartment: 'Bez działu',
    person: 'Osoba',
    source: 'Wymiar z',
    entitlement: 'Wymiar',
    carried: 'Zaległy',
    used: 'Wykorzystany',
    planned: 'Zaplanowany',
    remaining: 'Pozostało',
    edit: 'Wymiar',
    empty: 'Nikt nie pasuje do filtrów',
    erpOnly: 'tylko w InsERT — bez konta NEXOPS',
    usedSplit: 'Z InsERT: {erp} · z NEXOPS: {nexops} · w obu (liczone raz): {both}',
    rule: 'Wymiar: ręcznie w NEXOPS > InsERT > domyślny organizacji ({days} dni). Wykorzystany = dni robocze urlopu z InsERT i z grafiku NEXOPS — ten sam dzień liczy się raz. 1 dzień wymiaru = 8 h; przy niepełnym etacie dzień urlopu zużywa dobową normę osoby z RCP.',
    link: { AUTO: 'powiązano automatycznie', MANUAL: 'powiązano ręcznie' },
    away: 'urlop · wraca {day}',
    awayHint: 'Teraz na urlopie — wraca {day}',
  },
  upcoming: { title: 'Nadchodzące urlopy (60 dni)', empty: 'Brak urlopów w najbliższych 60 dniach', days: 'dni robocze: {n}' },
  entitlement: {
    title: 'Wymiar urlopu — {name}, {year}',
    description: 'Wpis ręczny ma pierwszeństwo przed InsERT i wymiarem domyślnym. Dni po 8 h (Kodeks pracy art. 154²).',
    current: 'Teraz:',
    currentValue: 'wymiar {ent}, zaległy {carried}',
    days: 'Wymiar (dni)',
    carried: 'Zaległy z poprzedniego roku (dni)',
    save: 'Zapisz ręcznie',
    cancel: 'Anuluj',
    reset: 'Przywróć InsERT / domyślny',
    resetHint: 'Usuwa wpis ręczny — wraca wymiar z InsERT albo domyślny organizacji.',
    saved: 'Zapisano wymiar urlopu',
    cleared: 'Przywrócono wymiar z InsERT / domyślny',
    failed: 'Nie udało się zapisać wymiaru',
    invalid: 'Podaj liczbę dni od 0 do {max} (co 0,1).',
    normHint: 'Dobowa norma osoby: {h} h (RCP → profil). Pozostałe dni wolnego = pula w godzinach ÷ norma.',
  },
  person: {
    subtitle: 'Urlop w {year}',
    norm: 'norma {h} h dziennie',
    months: 'Dni urlopu w miesiącach (InsERT / NEXOPS)',
    history: 'Urlopy w roku',
    empty: 'Brak urlopów w tym roku',
    onDemand: 'na żądanie',
    nowOn: 'Teraz na urlopie — wraca {day}',
    next: 'Najbliższy urlop: {from} – {to} (dni robocze: {n})',
  },
  calendar: {
    monthTotal: 'Osobodni urlopu: {n}',
    prev: 'Poprzedni miesiąc',
    next: 'Następny miesiąc',
    coverage: 'Zaznacz dni od liczby osób',
    holiday: 'Święto',
    nobody: 'Nikt nie ma urlopu tego dnia',
    pickDay: 'Kliknij dzień, żeby zobaczyć, kto ma urlop.',
    today: 'Dziś',
    less: 'mniej',
    more: 'więcej',
    dayTitle: 'Na urlopie: {n}',
    onLeave: 'Na urlopie: {n} os.',
    back: 'wraca {day}',
  },
  timeline: { empty: 'Nikt nie ma urlopu w tym roku', total: 'Dni robocze urlopu w roku', sort: { first: 'Wg terminu', name: 'Wg nazwiska', days: 'Wg liczby dni' } },
  requests: {
    mode: 'Widok wniosków',
    toDecide: 'Do decyzji',
    history: 'Historia',
    allStatuses: 'Każdy status',
    allTypes: 'Każdy rodzaj',
    wholeYear: 'Cały {year}',
    empty: 'Brak wniosków dla tych filtrów',
    emptyToDecide: 'Nic nie czeka na Twoją decyzję',
    workingDays: 'dni robocze: {n}',
    exceeds: 'Ponad saldo urlopu',
    before: 'Saldo przed',
    thisRequest: 'Ten wniosek',
    after: 'Saldo po',
    collisions: 'Inne urlopy w zespole w tym terminie',
    noCollisions: 'Nikt z zespołu nie ma wtedy urlopu',
    response: 'Odpowiedź',
    respondedBy: 'Rozpatrzył(a): {name}',
    notYours: 'Ten wniosek rozpatruje ktoś inny wg ustawienia organizacji.',
    comment: 'Komentarz do decyzji',
    commentPh: 'Komentarz (opcjonalnie) — trafi do pracownika i na wydruk',
    approve: 'Akceptuj',
    reject: 'Odrzuć',
    approved: 'Wniosek zaakceptowany',
    rejected: 'Wniosek odrzucony',
    failed: 'Nie udało się zapisać decyzji',
  },
  link: {
    description:
      'Pracownicy z Gratyfikanta (imię, nazwisko, wymiar i daty urlopów wypoczynkowych — bez L4 i innych nieobecności). Import łączy ich z kontami sam, gdy imię i nazwisko są jednoznaczne; resztę połącz tu. Ręcznie rozłączonego import nie połączy ponownie.',
    show: 'Pokaż',
    filter: { unlinked: 'Bez konta', linked: 'Powiązani', all: 'Wszyscy' },
    empty: 'Nikt nie pasuje do filtrów',
    noErp: 'Brak danych z InsERT — uruchom import „Urlopy pracowników” w Integracjach.',
    employee: 'Pracownik (InsERT)',
    years: 'Lata z danymi',
    account: 'Konto NEXOPS',
    mode: { AUTO: 'automatycznie', MANUAL: 'ręcznie' },
    pick: 'Wybierz konto…',
    linkBtn: 'Połącz',
    unlink: 'Rozłącz',
    linked: 'Połączono pracownika z kontem',
    unlinked: 'Rozłączono — import nie połączy go automatycznie',
    failed: 'Nie udało się zmienić powiązania',
  },
};

export type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };
